import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LmsUserService } from 'lms-api';
import { LmsAppSettings } from 'lms-api';

@Injectable({
  providedIn: 'root'
})
export class TrainingLicenseService {

  constructor(private httpClient: HttpClient, private userService: LmsUserService, private LmsAppSettings: LmsAppSettings) { }

  Get() {
    return this.httpClient.get(this.LmsAppSettings.pac_base_nf_url + 'api/PACMembershipTrainingDetail');
  }

  AddLicense(state: string, number: string) {
    let licenseObject = { License1: { State: state, Exempt: false, Raw: number }, Association: "ABMP", Primary: true };
    return this.httpClient.post(this.LmsAppSettings.pac_base_nf_url + 'api/PACMembershipTrainingDetail', licenseObject);
  }
}
